import { InjectionToken } from '@angular/core';
import { IbCNewPaymentAvailiabilityService } from 'ib-web-commons/http-services/public_api';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils'; 
export const AJSGiftCardsIbCNewPaymentAvailiabilityService = new InjectionToken('IbCNewPaymentAvailiabilityService');
export const AJSGiftCardsIbCNewPaymentAvailiabilityServiceProvider = upgradeAJSServiceProvider('IbCNewPaymentAvailiabilityService', AJSGiftCardsIbCNewPaymentAvailiabilityService);
export interface GiftCardsIbCNewPaymentAvailiabilityServiceType extends IbCNewPaymentAvailiabilityService {
    isNewPaymentAvailiability()
}
